import React, { Component } from "react";

import Hero from "../components/Hero";
import HomeCarousel from "../components/HomeCarousel";
import HomeUserDescription from "../components/HomeUserDescription";

class HomePage extends Component {
  componentWillMount() {
    document.title = "Home";
  }

  render() {
    return (
      <div>
        <a name="skipnav" id="skipnav">
          <Hero
            title="Welcome to the Neurosphere Simulator Toolbox"
            subTitle="Laboratory of Neurobiology at Northeastern University"
            text=""
          />
        </a>
        <div className="container">
          <div className="d-flex justify-content-center">
            <HomeCarousel />
          </div>
          <div className="row p-3">
            <p>
              As part of a research project funded by the{" "}
              <a
                className="b-link"
                href="https://nsf.gov/"
                target="_blank"
                rel="noopener noreferrer"
              >
                National Science Foundation
              </a>
              , the Laboratory of Neurobiology at Northeastern University has
              built computational models that simulate stem-cell-driven tissue
              growth
              <i> in vitro</i> and <i>in vivo.</i> Based on these models, this
              website provides the Neurosphere Simulator as a free online tool.
              This simulator has been designed primarily for educational
              purposes, but it offers many features that allow users to also
              explore its suitability for their research.
            </p>
          </div>
          <div className="row d-flex justify-content-center py-4">
            <div className="col-md-4 d-flex justify-content-center text-center">
              <HomeUserDescription
                title="LEARN MORE"
                link="/tutorial/1"
                buttonName="Tutorial"
                description="If you are new to cellular automata modeling and its application to developmental neurobiology, and would like to learn more, click here."
              />
            </div>
            <div className="col-md-4 d-flex justify-content-center text-center">
              <HomeUserDescription
                title="NEUROSPHERE SIMULATOR"
                link="/neurosphere"
                buttonName="Simulator"
                description="If you like to go directly to the Neurosphere Simulator, click here."
              />
            </div>
            <div className="col-md-4 d-flex justify-content-center text-center">
              <HomeUserDescription
                title="RESEARCH"
                link="/publications"
                buttonName="Research"
                description="If you are interested in the research that led to the development of the Neurosphere Simulator, click here."
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HomePage;
